class ProgressCircle extends HTMLElement {
  constructor() {
    super();
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            this.animateProgress();
            this.observer.unobserve(this);
          }, 200);
        }
      });
    });
  }

  connectedCallback() {
    this.progressBar = this.querySelector('.progress-circle__bar');
    this.progress = parseInt(this.getAttribute('progress') || '75');
    
    if (this.progressBar) {
      const pathLength = this.progressBar.getTotalLength();
      this.progressBar.style.strokeDasharray = pathLength;
      this.progressBar.style.strokeDashoffset = pathLength;
      
      this.observer.observe(this);
    }
  }

  animateProgress() {
    setTimeout(() => {
      this.progressBar.classList.add('progress-circle__bar--transition');
      const pathLength = this.progressBar.getTotalLength();
      const offset = pathLength - (this.progress / 100) * pathLength;
      this.progressBar.style.strokeDashoffset = offset;
    }, 100);
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }
}

customElements.define('progress-circle', ProgressCircle);